/* @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import createLoadableComponent from 'js/lib/createLoadableComponent';
import { isCourserian } from 'js/lib/user';

const styles = {
  radius: css`
    [role='button'] {
      border-radius: var(--cds-border-radius-50);
    }
  `,
};

const LoadableCoachStudio = createLoadableComponent(() => import('bundles/ai-coach-studio/ai-coach-studio-index'));

export const showCoachStudio = () => {
  return isCourserian();
};

const CoachStudioGridItem = () => {
  return (
    <div css={styles.radius}>
      <LoadableCoachStudio />
    </div>
  );
};

export default CoachStudioGridItem;
